export enum METHOD_FILES {
    GET = "get.json",
    POST = "post.json",
    PUT = "put.json",
    PATCH = "patch.json",
    DELETE = "delete.json"
}
